import { FC, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { postAsync } from "../../services/ApiHandler";
import { useHeaderStore } from "../../parts/CommonHeader";
import { isLoggedIn } from "../../services/CookieHandler";

export const AdvancedUpgradedPage: FC = () => {
  const search = useLocation().search;
  const { fetchActiveSubscription, fetchRemainCount } = useHeaderStore();

  useEffect(() => {
    const query = new URLSearchParams(search);
    const sessionId = query.get('session_id');
    if (sessionId !== undefined && isLoggedIn()) {
      postSessionId(sessionId!.toString());
    }
  }, []);

  async function postSessionId(sessionId: string) {
    const param = {
      sessionId: sessionId
    };
    await postAsync<string>("Stripe/CompletePurchase", param); 
    fetchActiveSubscription();
    fetchRemainCount();
  }

  return <>
    <Helmet>
      <title>Advancedアップグレード完了</title>
      <meta name="description" content="Advancedアップグレード完了" />
    </Helmet>
      <div className="mt-4 text-base sm:text-lg font-bold">Advancedプランの申込が完了しました！</div>
  </>;
}
